export const SidebarData2 = [
    {
      title: 'My Account',
      cName: 'nav-text',
      link:"/user"
    },
    {
      title: 'Need Help',
      
      
      cName: 'nav-text',
      link:"*"
    },
    {
      title: 'About us',
     
     
      cName: 'nav-text',
      link:"*"
    },
    {
      title: 'Guide',
      
     
      cName: 'nav-text',
      link:"*"
    },
    
  ];
  
  
  export default SidebarData2
  